import {
  COMPONENT_VALUE_TYPES as types,
  REGIONS
} from 'shared/constants';

const propsSchema = [
  {
    key: 'event_name',
    label: 'Event Name',
    type: types.TEXT
  },
  {
    key: 'event_time',
    label: 'Event Time',
    type: types.TEXT
  },
  {
    key: 'event_location',
    label: 'Event Location',
    type: types.TEXT
  },
  {
    key: 'event_landing_url',
    label: 'Event Landing Page URL',
    type: types.TEXT
  },
  {
    key: 'background_image_url',
    label: 'Background Image URL',
    type: types.TEXT
  },
  {
    key: 'region',
    label: 'Region',
    type: types.ENUM,
    options: REGIONS
  },
];

const defaultProps = {
  event_name: 'New Event',
  event_time: '01/01',
  event_location: 'Event Location',
  event_landing_url: 'https://www.ff.com',
  background_image_url: '',
  region: 'US'
};

export default {
  title: 'Event Preview',
  id: 'EventPreview',
  widgetImage: '/widgetImages/Event+Overview.png',
  basic: true,
  propsSchema,
  defaultProps
};
